import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <mask id="ursa-icon__ExclamationAlertErrorIcon__16__ida" fill="#fff">
            <path
                fillRule="evenodd"
                d="M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
                clipRule="evenodd"
            />
            <path
                fillRule="evenodd"
                d="M8 8.9a.7.7 0 0 0 .7-.7V5.7a.7.7 0 1 0-1.4 0v2.5a.7.7 0 0 0 .7.7"
                clipRule="evenodd"
            />
            <path d="M7.25 10.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0" />
        </mask>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8 8.9a.7.7 0 0 0 .7-.7V5.7a.7.7 0 1 0-1.4 0v2.5a.7.7 0 0 0 .7.7"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M7.25 10.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0" />
        <path
            fill="currentColor"
            d="M7.25 10.25h-1zM8 11v-1zm.75-.75h-1zM8 9.5v-1zM4.4 8A3.6 3.6 0 0 1 8 4.4v-2A5.6 5.6 0 0 0 2.4 8zM8 11.6A3.6 3.6 0 0 1 4.4 8h-2A5.6 5.6 0 0 0 8 13.6zM11.6 8A3.6 3.6 0 0 1 8 11.6v2A5.6 5.6 0 0 0 13.6 8zM8 4.4A3.6 3.6 0 0 1 11.6 8h2A5.6 5.6 0 0 0 8 2.4zM8 1a7 7 0 0 0-7 7h2a5 5 0 0 1 5-5zm7 7a7 7 0 0 0-7-7v2a5 5 0 0 1 5 5zm-7 7a7 7 0 0 0 7-7h-2a5 5 0 0 1-5 5zM1 8a7 7 0 0 0 7 7v-2a5 5 0 0 1-5-5zm6.7.2a.3.3 0 0 1 .3-.3v2a1.7 1.7 0 0 0 1.7-1.7zm0-2.5v2.5h2V5.7zM8 6a.3.3 0 0 1-.3-.3h2A1.7 1.7 0 0 0 8 4zm.3-.3A.3.3 0 0 1 8 6V4a1.7 1.7 0 0 0-1.7 1.7zm0 2.5V5.7h-2v2.5zM8 7.9a.3.3 0 0 1 .3.3h-2A1.7 1.7 0 0 0 8 9.9zm-1.75 2.35c0 .966.783 1.75 1.75 1.75v-2a.25.25 0 0 1 .25.25zM8 12a1.75 1.75 0 0 0 1.75-1.75h-2A.25.25 0 0 1 8 10zm1.75-1.75A1.75 1.75 0 0 0 8 8.5v2a.25.25 0 0 1-.25-.25zM8 8.5a1.75 1.75 0 0 0-1.75 1.75h2a.25.25 0 0 1-.25.25z"
            mask="url(#ursa-icon__ExclamationAlertErrorIcon__16__ida)"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
